export enum ClickType {
  '热搜词' = 0,
  '换一换' = 1,
  '搜索按钮' = 2,
  '联系客服' = 3,
  '历史记录' = 4,
}
